package org.vreo.devicehub.features.roi.data

import kotlin.io.encoding.Base64

import org.vreo.devicehub.features.core.domain.DataError
import org.vreo.devicehub.features.core.domain.EmptyResult
import org.vreo.devicehub.features.core.domain.Result
import org.vreo.devicehub.features.core.domain.device.device.networking.RemoteDeviceControl
import org.vreo.devicehub.features.core.domain.device.imageRequest.StaticImageRequest
import org.vreo.devicehub.features.core.domain.device.roi.Roi
import org.vreo.devicehub.features.roi.domain.RoiRepository


/**
 * Roi repository default. Allows to configure ROI on the target device using Tensor backend services.
 *
 * @property deviceControl Provides access to device control methods
 */
class RoiRepositoryDefault(
    val deviceControl: RemoteDeviceControl,
) : RoiRepository {
    override suspend fun getStaticImage(
        token: String,
        deviceId: String,
        config: StaticImageRequest
    ): Result<ByteArray, DataError.Remote> {
        return when (val results = deviceControl.getStaticImage(token, deviceId, config)) {
            is Result.Success -> {
                val base64Image = results.data.imageBase64
                if (base64Image.isNullOrBlank()) {
                    return Result.Error(DataError.Remote.INVALID_ARGUMENT)
                }
                val decodedImage = Base64.decode(base64Image)
                Result.Success(decodedImage)
            }

            is Result.Error -> {
                results
            }
        }
    }

    override suspend fun getRoiConfiguration(
        token: String,
        deviceId: String
    ): Result<List<Roi>, DataError.Remote> {
        return deviceControl.getRoiConfiguration(token, deviceId)
    }

    override suspend fun setRoiConfiguration(
        token: String,
        deviceId: String,
        config: List<Roi>
    ): EmptyResult<DataError.Remote> {
        return deviceControl.setRoiConfiguration(token, deviceId, config)
    }
}